import { Card, Stack } from '@mui/material';
import {
    ListBase,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
    useGetIdentity,
    useListContext,
} from 'react-admin';

import { ticketStatuses } from '@/root/defaultConfiguration';
import { TicketListContent } from './TicketListContent';
import { TicketListFilter } from './TicketListFilter';

export const TicketList = () => {
    const { identity } = useGetIdentity();

    if (!identity) return null;

    return (
        <ListBase
            disableAuthentication
            perPage={25}
            sort={{ field: 'id', order: 'DESC' }}
            filterDefaultValues={{ status: ticketStatuses.pending }}
        >
            <TicketListLayout />
        </ListBase>
    );
};

const TicketListLayout = () => {
    const { isPending } = useListContext();
    const { identity } = useGetIdentity();

    if (!identity || isPending) return null;

    return (
        <Stack direction={{ xs: 'column', md: 'row' }} sx={{ width: '100%' }}>
            <TicketListFilter />
            <Stack sx={{ width: '100%', minWidth: 0, flex: 1 }}>
                <Title title="Tickets" />
                <ListToolbar actions={<TicketListActions />} />
                <Card>
                    <TicketListContent />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const TicketListActions = () => (
    <TopToolbar>
        <SortButton fields={['id', 'created_at', 'status']} />
    </TopToolbar>
);
